






import { Component, Vue, Prop } from 'nuxt-property-decorator';

@Component
export default class XScenenBackground extends Vue {
  @Prop(String)
  color?: string

  get colorClass () {
    if (!this.color)
      return null;

    return `color-${this.color}`;
  }
}
